import { render, staticRenderFns } from "./General.vue?vue&type=template&id=2396ef63&"
import script from "./General.vue?vue&type=script&lang=ts&"
export * from "./General.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports